import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar/AppBar';
import { CSSObject, styled, Theme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import {
    CHAT_ASSISTANTS,
    HOME,
    LICITACIONES,
    USERS,
} from '../../../routes/paths';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import SettingsIcon from '@mui/icons-material/Settings';
import DescriptionIcon from '@mui/icons-material/Description';
import { ModulesMessages } from '../../../shared/messages/modulesMessages';
import { UserTypeEnum } from '../../../shared/types/shared';
interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

export const drawerWidth = 300;
const appBarHeight = 80;

export const openedMixin = (theme: Theme, hideTopBar: boolean): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    height: hideTopBar ? '100%' : `calc(100% - ${appBarHeight}px)`,
    top: hideTopBar ? 0 : appBarHeight,
    backgroundColor: theme.palette.common.sidebar,
    color: theme.palette.common.contrastText,
});

export const closedMixin = (theme: Theme, hideTopBar: boolean): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    height: hideTopBar ? '100%' : `calc(100% - ${appBarHeight}px)`,
    top: hideTopBar ? 0 : appBarHeight,
    width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(10)} + 1px)`,
    },
    backgroundColor: theme.palette.common.sidebar,
    color: theme.palette.common.contrastText,
});

export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

export const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open' && prop !== 'hideTopBar',
})<{ open?: boolean; hideTopBar?: boolean }>(({ theme, open, hideTopBar }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    borderColor: theme.palette.primary.contrastText,
    ...(open && {
        ...openedMixin(theme, !!hideTopBar),
        '& .MuiDrawer-paper': openedMixin(theme, !!hideTopBar),
    }),
    ...(!open && {
        ...closedMixin(theme, !!hideTopBar),
        '& .MuiDrawer-paper': closedMixin(theme, !!hideTopBar),
    }),
}));

export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    borderColor: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        borderColor: theme.palette.primary.contrastText,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const { HOME_MODULE, ASSISTANT_MODULE, TENDERS, ADMIN } = ModulesMessages;

export const ModulesSideBar = [
    {
        route: HOME,
        label: HOME_MODULE,
        icon: <HomeRoundedIcon sx={{ color: 'common.contrastText' }} />,
    },
    {
        route: CHAT_ASSISTANTS,
        label: ASSISTANT_MODULE,
        icon: <HeadsetMicIcon sx={{ color: 'common.contrastText' }} />,
        permissions: [UserTypeEnum.SuperAdmin],
    },
    {
        route: USERS,
        label: ADMIN,
        icon: <SettingsIcon sx={{ color: 'common.contrastText' }} />,
        permissions: [UserTypeEnum.Admin],
    },
    {
        route: LICITACIONES,
        label: TENDERS,
        icon: <DescriptionIcon sx={{ color: 'common.contrastText' }} />,
    },
];
